export type School = {
  id: number;
  title: string;
  short: string;
  bms: boolean;
};

export function getSchoolTranslation(school: School) {
  return `${school.short} (${school.title})`;
}

export function getSchoolOptions(schools: School[]) {
  return schools.map((school) => ({
    value: school.id.toString(),
    label: getSchoolTranslation(school),
  }));
}
